export const role = {
    /**
    * Gets the programmatic name of the entire locale, with the language, 
    *   country and variant separated by underbars. The Language is always lower case, 
    *   and country is always upper case. If the language is missing, 
    *   the string will begin with an underscore character. 
    *   If both the language and country fields are missing, 
    *   this function will return the empty string, 
    *   even if the variant field is filled in (you cannot have a locale with just a variant-- 
    *   the variant must accompany a valid language or country code). Examples: "en"
    *
    */
    en:{
        page:{
            title: 'Roles And Permissions'
        },
        add_role: 'Add Role',
        role_name: 'Role Name',
        role_type: 'Role Type',
        name: 'Roles Permissions',
        select_all:"Select All",
        create:"Create",
        view:"View",
        delete:"Delete",
        edit:"Edit",
        user_onboarding:"User Onboarding",
        device_onboarding:"Device Onboarding",
        device_allocation:"Device Allocation",
        sms_template:"SMS Template",
        address_onboarding:"Address Onboarding",
        pole_onboarding:"Pole Onboarding",
        lamp_onboarding:"Lamp Onboarding",
        led_load_onboarding:"LED Load Onboarding",
        device_installation_report:"Device Installation Report",
        add:{
            success: 'Role added successfully',
            error: 'Unable to add the role. Please try again.'
        },
        permission:{
            empty: 'Please select atleast one value',
            add:{
                success: 'Permission added successfully',
                error: 'Unable to add the permission. Please try again.'
            },
            display:{
                error: 'Something went wrong. Please try again'
            }
        },
    },

    ar:{
        page:{
            title: 'الأدوار والتصاريح'
        },
        add_role: 'أضف دورًا',
        role_name: 'اسم الدور',
        role_type: 'نوع الدور',
        name: 'تصاريح الأدوار',
        select_all:"اختر الكل",
        create:"إنشاء",
        view:"عرض",
        delete:"حذف",
        edit:"تعديل",
        user_onboarding:"إعداد المستخدم",
        device_onboarding:"إعداد الجهاز",
        device_allocation:"تخصيص الجهاز",
        sms_template:"قالب SMS",
        address_onboarding:"العنوان على متن الطائرة",
        pole_onboarding:"قطب على متن الطائرة",
        lamp_onboarding:"قطب على متن الطائرة",
        led_load_onboarding:"تحميل على متن الطائرة LED",
        device_installation_report:"تقرير تثبيت الجهاز",
        add:{
            success: 'تمت إضافة الدور بنجاح',
            error: 'غير قادر على إضافة الدور. حاول مرة اخرى.'
        },
        permission:{
            empty: 'الرجاء تحديد قيمة واحدة على الأقل',
            add:{
                success: 'تمت إضافة الإذن بنجاح',
                error: 'غير قادر على إضافة الإذن. حاول مرة اخرى.'
            },
            display:{
                error: 'هناك خطأ ما. حاول مرة اخرى'
            }
        },
    }
}